import { render } from "./backgroundMedia.vue?vue&type=template&id=069058a4&scoped=true"
import script from "./backgroundMedia.vue?vue&type=script&lang=js"
export * from "./backgroundMedia.vue?vue&type=script&lang=js"

import "./backgroundMedia.vue?vue&type=style&index=0&id=069058a4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\medrina-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069058a4"]])

export default __exports__